module.exports = __webpack_public_path__ + "img/bluetooth-icon.1454aaf9.png";